import React, { useContext } from 'react';
import { ICredentialsContext, CredentialsContext } from '../../../../credentialsState/credentialsContext';
import Text from 'components/Text/Text';
import { Item } from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

export const List: React.FC = () => {
	const { credentials } = useContext<ICredentialsContext>(CredentialsContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const apiKeyHeadingClasses = classNames(style.apiKey, style.heading);
	const apiSecretHeadingClasses = classNames(style.apiSecret, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="ISVCredentialLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={apiKeyHeadingClasses}
					translationNameSpace="listing"
					translationKey="credentialApiKeyLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={apiSecretHeadingClasses}
					translationNameSpace="listing"
					translationKey="credentialApiSecretLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{credentials.credentialItems.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};
